(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drift-shopping-tabs"] && !Shopify.designMode) return;
  try {
    
function initDriftEdit(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const tabs = [...root.querySelectorAll('[role="tab"]')];
  function select(tab) {
    tabs.forEach((t) => {
      const active = t === tab;
      t.setAttribute('aria-selected', active);
      t.tabIndex = active ? 0 : -1;
      root.querySelector('#' + t.getAttribute('aria-controls')).hidden = !active;
    });
  }
  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => select(tab));
    tab.addEventListener('keydown', (e) => {
      let n;
      if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
      if (e.key === 'ArrowLeft') n = (i + tabs.length - 1) % tabs.length;
      if (n !== undefined) { e.preventDefault(); select(tabs[n]); tabs[n].focus(); }
    });
  });
}
document.querySelectorAll('.dt-edit').forEach(initDriftEdit);
document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('.dt-edit').forEach(initDriftEdit));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
